/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-alert */
import { toast } from "react-toastify";
import ApiService from "./networkApi";

const {
  calculateMatchTeeTimeForIndividuals,
  calculateMatchTeeTimeForTeams,
} = require("./firebase");

async function submitTeeTime(eventId, teeTimeId, teamsPlay) {
  try {
    const result = teamsPlay
      ? await calculateMatchTeeTimeForTeams(eventId, teeTimeId)
      : await calculateMatchTeeTimeForIndividuals(eventId, teeTimeId);
    let { isMatchCompleted, players } = result;
    if (result.convertToIndividuals) {
      ({ isMatchCompleted, players } =
        await calculateMatchTeeTimeForIndividuals(eventId, teeTimeId));
    }
    if (isMatchCompleted) {
      // await ApiService.twilioMatchCompleteMessage(eventId, players);
      console.log({ players });
    }
  } catch (e) {
    console.log("submitTeeTime", e);
    // it should never happens
    toast.warn(
      `Whoops, something bad happened. ${
        teamsPlay &&
        "It seems there are not enough players in the other team." +
          "And we're still working on it."
      } Code: 14`,
      {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      },
    );
    throw new Error();
  }
}

export { submitTeeTime };
